<template>
  <div class="lock" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="search">
      <div class="left" @click="$router.push('citys')">
        <span>当前位置</span>
        <font>{{cityData.length <=0 ? '定位中...' : cityData.cityName}}</font>
      </div>
    </div>
    <div style="height:55px"></div>
    <ul>
      <li v-for="(item,i) in lock" :class="i > 0 ? 'lock-list' : 'curt'"  @click="toPush(item.id,'lockDetail')">
        <img class="fmt" :src="baseUrl+item.img" />
        <div class="right">
        <h2>{{item.title}}</h2>
        <div class="price">
          <i><b>¥</b> {{item.rate.split(".")[0]}}.<b>{{item.rate.split(".")[1]}}</b></i>
          <span>￥{{item.price}}</span>
        </div>
        <!--<a>立即预约</a>-->
        </div>
      </li>
    </ul>
    <div class="none" v-if="lock.length <= 0">
      <p>您所在的<font>{{cityData.length <=0 ? '定位中...' : cityData.cityName}}</font>地区，暂无数据...</p>
      <a @click="$router.push('citys')">切换地区</a>
    </div>
    <div style="height:55px"></div>
    <div class="footer">
      <div class="footer-item on" @click="$router.push('lock')">
        <p><i class="el-icon-document" style="font-size:24px;"></i></p>
        茶室列表
      </div>
      <div class="footer-item" @click="$router.push('take')">
        <p><i class="el-icon-folder-opened" style="font-size:24px;"></i></p>
        接单中心
      </div>
      <div class="footer-item" @click="$router.push('lockcard')">
        <p><i class="el-icon-postcard" style="font-size:24px;"></i></p>
        空间卡
      </div>
    </div>
  </div>
  
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        code:'',
        lock:[],
        cityData:[],
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/lock');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        if(localStorage.getItem('cCode') == null){
          this.getQquey();
        }else{
          var cCode = JSON.parse(localStorage.getItem('cCode'));
          if(cCode.expires <= Date.parse(new Date())){
            localStorage.removeItem('cCode');
            this.getQquey();
          }else{
            this.cityData = cCode;
            this.locks();
          }
        }
      }

    },
    mounted() {
      this.beforeMount();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'getLocation',
              'openLocation'
            ]
          });
          wx.ready(function() {
            that.fullscreenLoading = true;
            wx.getLocation({
              type: 'wgs84',
              success: function (res) {
                $.ajax({
                  type:'post',
                  url:that.$host+'home/movies/getAddressInfo',
                  data:{
                    latitude:res.latitude,
                    longitude:res.longitude,
                  },
                  dataType:'json',
                  success:function(data){
                    var expires = Date.parse(new Date()) / 1000;
                    expires = (expires + 1800) * 1000;
                    var data = {
                      cityCode:data.data.city_code,
                      cityName:data.data.city,
                      expires:expires,
                      latitude:res.latitude,
                      longitude:res.longitude,
                      key:0
                    };
                    localStorage.setItem('cCode', JSON.stringify(data));
                    that.cityData = data;
                    that.locks();
                  }
                })
              }
            });
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      locks:function(){
        var that = this; 
        that.fullscreenLoading = true
        $.ajax({
          type:'post',
          url:that.$host+'home/lock/getIndex',
          data:{
            latitude:that.cityData.latitude,
            longitude:that.cityData.longitude,
            keywords:(that.cityData.key == 1 ? that.cityData.cityName : '')
          },
          dataType:'json',
          success:function(data){
            that.lock = data.data
            that.fullscreenLoading = false
          }
        })
      },

      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .lock{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  .lock .search{
    position:fixed;
    width:100%;
    left:0;
    background:#ececec;
    height:55px;
    top:0;
    z-index:99
  }


  .lock .search .left{
    float:left;
    height:55px;
    width:33%;
    margin-left:3%;
    position: relative;
  }
  .lock .search .left span{
    width:40px;
    float:left;
    font-size:15px;
    color:#000;
    line-height:18px;
    position: relative;
    top:50%;
    transform: translateY(-50%);
  }
  .lock .search .left span:after{
    position:absolute;
    content:'';
    width:3px;
    height:3px;
    background:#000;
    border-radius:10px;
    right:0
  }
  .lock .search .left font{
    width:calc(100% - 47px);
    float:left;
    font-size:15px;
    line-height:18px;
    margin-left:7px;
    color:#666;
    position: relative;
    top:50%;
    transform: translateY(-50%);
  }

  .lock ul{
    width:100%;
    display: block;
    margin: 0 auto;
  }
  .lock ul li.curt{
    position:relative;
    margin-bottom:15px
  }
  .lock ul li.curt .fmt{
    display:block;
    width:100%
  }
  .lock ul li.curt .right{
    position:absolute;
    bottom:0px;
    height:55px;
    background:rgba(0,0,0,.5);
    width:100%
  }
  .lock ul li.curt .right h2{
    font-size:15px;
    color:#fff;
    float:left;
    height:55px;
    line-height:55px;
    width:70%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1px;
    margin-left:4%
  }

  .lock ul li.curt .price{
    float:right;
    height:55px;
    margin-right:4%;
    text-align:center;
    margin-top:8px
  }
  .lock ul li.curt .price span{
    text-decoration: line-through;
    color:#ccc;
    font-size:12px;
    display:block
  }


  .lock ul li.curt .price{
    font-size: 15px;
    font-family: PingFang SC;
    color: #333333;
  }
  .lock ul li.curt .price i{
    color: #f00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .lock ul li.lock-list .price b{
    font-size:12px;
  }

  .lock ul li.lock-list{
    background:#fff;
    border-radius:8px;
    width:94%;
    padding:13px 0;
    position:relative;
    margin:0 auto 15px auto;
  }
  .lock ul li.lock-list:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .lock ul li.lock-list .fmt{
    float:left;
    width:30%;
    border-radius:6px;
    margin-left:3%
  }
  .lock ul li.lock-list .right{
    float:left;
    width:65%;
    margin-left:2%;
  }
  .lock ul li.lock-list h2{
    font-size:15px;
    padding:8px
  }
  .lock ul li.lock-list .price{
    padding-bottom:20px;
    padding-top:15px
  }
  .lock ul li.lock-list .price span{
    text-decoration: line-through;
    color:#999;
    font-size:14px;
    padding-left:10px;
  }


  .lock ul li.lock-list .price{
    font-size: 15px;
    font-family: PingFang SC;
    color: #333333;
  }
  .lock ul li.lock-list .price i{
    color: #f00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .lock ul li.lock-list .price b{
    font-size:12px;
  }
  .lock ul li.lock-list a{
    position:absolute;
    right:20px;
    top:60%;
    transform: translateY(-50%);
    color:#2F78FF;
    border: 1px solid #2F78FF;
    border-radius: 30px;
    width: 83px;
    height: 30px;
    text-align:center;
    line-height:30px;
    font-weight: 600;
    font-size:14px;
  }
  .lock .none{
    width:80%;
    margin:0 auto;
    padding-top:20%
  }
  .lock .none p{
    color:#333;
    font-size:15px;
    width:100%;
    text-align:center;
    margin-bottom:30px
  }
  .lock .none p font{
    color:#e45442;
    font-weight:bold;
    padding:0 2px
  }
  .lock .none a{
    display:block;
    background: #0059D6;
    height: 45px;
    border-radius: 8px;
    width:140px;
    text-align:center;
    line-height: 45px;
    color:#fff;
    margin:0 auto;
  }
</style>